import './index.less';

export default {
  template: `
    <div class="rate-container">
     <div class="star-tip">
      <div class="gray">
        <img src="//img.alicdn.com/tfs/TB1jayDl26H8KJjy0FjXXaXepXa-150-28.png" />
      </div>
      <div class="light" v-bind:style="{width:precent}">
        <img src="//img.alicdn.com/tfs/TB1Fo5ol4rI8KJjy0FpXXb5hVXa-150-28.png" />
      </div>
     </div>
     ({{value}}/5)
    </div>
  `,
  props:['value'],
  mounted:function(){

  },
  methods:{

  },
  computed:{
    precent:function(){
      return (this.value/5*100)+'%';
    }
  }
};


// WEBPACK FOOTER //
// ./src/components/rate/index.js